import { useMemo } from "react";

import { useConfiguration } from "@src/api/configurations/use-configuration";

export function useProgressBarCurrencyFormatter() {
  const currencyConfiguration = useConfiguration<{ code: string }>(
    "currency_format"
  );
  const shopConfiguration = useConfiguration<{
    code: string;
    locale: string;
  }>("shop_currency");
  const currency =
    currencyConfiguration?.value?.code ||
    shopConfiguration?.value?.code ||
    "USD";
  const locale = shopConfiguration?.value?.locale ?? "en";

  return useMemo(() => {
    const formatter = new Intl.NumberFormat(locale, {
      style: "currency",
      currency,
      maximumFractionDigits: 0,
    });
    return (price: number | string): string => {
      if (typeof price === "string") {
        return price;
      }
      return formatter.format(price);
    };
  }, [currency, locale]);
}
